import styled, { css } from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';
import {
  compose,
  space,

  // types
  SpaceProps,
} from 'styled-system';

import { ThemeProps } from 'types/styled';

import Box from 'components/elements/Box';
import { SmallStyledIcon } from 'components/base/CustomerIcon/CustomerIcon';

import { DefinitionLabel } from 'styles/base-classes';
import colors from 'styles/themes/colors';

type OpenPopupButtonProps = SpaceProps;

export const OpenPopupButton = styled.button<OpenPopupButtonProps>`
  appearance: none;
  background: white;
  font-size: ${modularScale(-2)};
  color: ${(p: any): string => p.theme.NightBlue};
  letter-spacing: 0.1em;
  text-align: center;
  border-radius: 0.2em;
  font-weight: 600;
  line-height: 1.6;
  text-transform: uppercase;
  box-sizing: content-box;
  position: relative;
  white-space: nowrap;
  margin: 0;
  border: 1px solid white;
  margin-left: ${({ theme }): string => theme.spacing.xsmall};
  padding: ${({ theme }): string =>
    `0 ${theme.spacing.medium} 0 ${theme.spacing.medium}`};
  display: flex;
  align-items: center;

  &.subscribed {
    background: transparent;
    color: white;
  }

  &.placeholder {
    visibility: hidden;
  }

  & svg {
    vertical-align: middle;
    margin: 3px 3px 3px 0;
  }

  ${compose(space)}
`;

export const OutlinedOpenPopupButton = styled(OpenPopupButton)<
  ThemeProps<'button'>
>`
  background: none;
  color: white;
  padding-top: ${({ theme }): string => theme.space[1]};
  padding-bottom: ${({ theme }): string => theme.space[1]};
`;

export const ButtonBox = styled(Box)<ThemeProps<'div'>>`
  ${({ isOpen, isSubscriptionForm }): any => css`
    @media screen and (max-width: 47em) {
      background: ${isOpen && !isSubscriptionForm ? colors.Sand : 'white'};

      padding: ${({ theme }): string =>
        `${modularScale(-2)} ${theme.spacing.medium} ${modularScale(
          -2
        )} 0.75rem `};
    }
  `}
`;

export const CategoryDefinitionLabel = styled(DefinitionLabel)`
  margin: 0.75rem 0.3rem;
  font-size: 13px;

  @media screen and (max-width: 47rem) {
    margin: 0.5rem 0;
  }
`;

export const BoxShadowed = styled(Box)`
  &:hover {
    background-color: ${({ theme }): string => theme.Sand};
  }
`;

export const CloseButton = styled('button')`
  display: flex;
  margin-top: -1em;
  margin-right: -1.25em;
`;

export const CustomerBox = styled(Box)`
  ${SmallStyledIcon} {
    margin-left: 0;
  }
`;

export const Top = styled('div')`
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: #001247;
  width: 100%;
  border-bottom: 1px solid #d4d8dd;
  padding-bottom: 32px;
  margin-bottom: 32px;
`;

export const NotifierBannerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Section = styled('div')`
  display: flex;
  gap: 32px;
`;

export const Button = styled('a')<any>`
  margin: 0 0 34px 0;
  color: #0bd6a7;
  background: #ffffff;
  height: 50px;
  width: ${({ width }): string => (width ? width : '232px')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #0bd6a7;
  border-radius: 0;
  cursor: pointer;

  svg {
    margin-bottom: ${({ marginBottom }): string =>
      marginBottom ? marginBottom : '5px'};

    ${({ isInterested }): string =>
      !isInterested
        ? `
      path {
        fill: #0bd6a7;
      }
      `
        : `
      transform: scale(1.25);
      margin-bottom: 2px;
      `}
  }
`;

export const InnerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const MobileButton = styled('button')<{
  type: string;
  isUnderlined: boolean;
}>`
  padding: 0;
  font-size: 0.875em;
  line-height: 1em;
  ${({ isUnderlined }): any =>
    isUnderlined &&
    css`
      border-bottom: 1px solid ${colors.AccentGreen};
      padding: 0 0 2px 0;
    `};

  &:focus,
  &:active,
  &:hover {
    background-color: ${colors.Sand};
  }
`;
